<template>
  <el-date-picker
    popper-class="form-common-datepicker"
    class="date-range-picker"
    v-model="datetime"
    type="daterange"
    value-format="yyyy-MM-dd"
    unlink-panels
    range-separator="至"
    start-placeholder="开始日期"
    end-placeholder="结束日期"
    :clearable="clearable"
    :picker-options="pickerOpts"
    v-bind="$attrs"
    @change="dateRangeChange"
  >
  </el-date-picker>
</template>
<script>
import shortcuts from '@/data/elementui-date-shortcuts.js'
export default {
  props: {
    value: {
      type: Array
    },
    pickerOptions: {
      type: Object,
      default() {
        return {}
      }
    },
    clearable: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      pickerOpts: Object.assign(
        {
          shortcuts,
          disabledDate(date) {
            return date && date.valueOf() > Date.now()
          }
        },
        this.pickerOptions
      )
    }
  },
  computed: {
    datetime: {
      get() {
        return this.value
      },
      set(dates) {
        this.$emit('input', dates)
      }
    }
  },
  methods: {
    dateRangeChange(v) {
      this.$emit('change', v)
    }
  }
}
</script>
<style lang="scss" scoped></style>
